import { render } from "./DocumentTypesAdditionalFields.vue?vue&type=template&id=bfe6e4ae"
import script from "./DocumentTypesAdditionalFields.vue?vue&type=script&lang=js"
export * from "./DocumentTypesAdditionalFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app/natviol-app/releases/880/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__